import { faGear } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans, useLingui } from '@lingui/react/macro';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@repo/videa-components';
import classNames from 'classnames';
import { useSetAtom } from 'jotai';

import { isPreferenceMenuOpen } from '@/app/appHeader/atoms';

interface PerioChartGearButtonProps {
  isDarkMode: boolean;
  onClick: () => void;
}

export const PerioChartGearButton = ({
  isDarkMode,
  onClick,
}: PerioChartGearButtonProps) => {
  const { t } = useLingui();
  const setIsPreferenceMenuOpen = useSetAtom(isPreferenceMenuOpen);

  const handleClick = () => {
    onClick();
    setIsPreferenceMenuOpen(true);
  };

  return (
    <Tooltip delayDuration={300}>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={classNames('vai-rounded-sm vai-p-1 vai-text-zinc-500', {
            'hover:vai-text-zinc-100': isDarkMode,
            'hover:vai-text-zinc-950': !isDarkMode,
          })}
          onClick={handleClick}
          aria-label={t`Customize gingival margin display`}
        >
          <FontAwesomeIcon size="lg" icon={faGear} />
        </button>
      </TooltipTrigger>
      <TooltipContent
        className="vai-w-40 vai-text-center"
        variant={isDarkMode ? 'dark' : 'default'}
        side="bottom"
      >
        <p>
          <Trans>Customize gingival margin display</Trans>
        </p>
      </TooltipContent>
    </Tooltip>
  );
};
